import React, { useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getDefaultRoute, isTechnicianRestrictedPath } from "../utils/roles";

export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const from = (location.state && location.state.from) || { pathname: "/dashboard" };

  const resolveDestination = (sessionUser) => {
    const fromPath = from?.pathname || "/";
    if (fromPath !== "/" && !isTechnicianRestrictedPath(fromPath)) {
      return from;
    }
    return { pathname: getDefaultRoute(sessionUser) };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const sessionUser = await login(username.trim(), password);
      history.replace(resolveDestination(sessionUser));
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Sign in</h1>
        <div className="auth-hint">
          <h2 className="auth-hint-title">Try your current password</h2>
          <p className="auth-hint-body">
            If you already have a My E-Crane account, sign in with the same email or username
            and password you use today. If that does not work, use Forgot password.
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="auth-error">{error}</div>}
          <div className="auth-field">
            <label className="auth-label">Email or username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username email"
              required
              className="auth-input"
            />
          </div>
          <div className="auth-field-last">
            <label className="auth-label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="auth-input"
            />
          </div>
          <div className="edit-section">
            <button type="submit" disabled={submitting}>
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
        <p className="auth-footer">
          <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
        </p>
      </div>
    </div>
  );
}
